import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const restoreMissionAction = createAsyncThunk(
    'restore-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/restore-mission/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const restoreMissionSlice = createSlice({
    name: 'restore-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(restoreMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(restoreMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(restoreMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const restoreMissionReducer = restoreMissionSlice.reducer    